const setIsCreatedNewAttendedAction = ({ commit }, payload) => {
  commit('setIsCreatedNewAttended', payload)
}

export default {
  setIsCreatedNewAttendedAction,
}
